module.exports = __webpack_public_path__ + "img/202504_08.ec78980e.jpg";